<template>
  <PageContent>
    <StepsV2 type="s3" :step="3" />
    <PanelV2
      type="w6"
      :title="$t('APP-FIELD-0265')"
      @nextClick="commitData"
    >
      <template v-slot:title-solt>
        <BdoProgress total="3" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="idCard" @uploadData="uploadData" :photoData="formData" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  import IdCardUpload from "./common/IdCardUpload";
  import API from "@/api";
  export default {
    name: 'PartnershipI',
    pRouter: 'PartnershipH',
    components: {
      IdCardUpload,
    },
    data() {
      return {
        formData: { idCardiUrl: '' }
      }
    },
    methods: {
      uploadData(val){
        this.formData.idCardiUrl = val
      },
      commitData() {
        if (this.formData.idCardiUrl == "") {
          this.showMessageTip('Upload your selfie with ID')
          return
        }
        const data = this.formatCommitData({...this.formData})
        API.addBdoProcess({
          ...data
        }).then((res) => {
          if (res.success === true) {
            this.toNext();
          }
        });
      },
    }
  }
</script>


<style lang="scss" scoped>

</style>
